<template>
<div id="app">
  <Nav :info="data.nav" :isMobile="isMobile"/>
  <div class="main">
    <div class="banner" :style="{backgroundImage: `url(${isMobile ? data.banner.mobile.url : data.banner.pc.url})`}">
      <More class="banner-btn" 
      :title="isMobile ? data.banner.mobile.btnText : data.banner.pc.btnText" 
      type="white" 
      :link="isMobile ? data.banner.mobile.link : data.banner.pc.link"/>
    </div>
    <div class="desc">
      <div class="container">
        <p v-for="(item, i) in data.desc" :key="i" v-html="item"></p>
      </div>
    </div>
    <!-- 数字基建 -->
    <div class="part num" id="num">
      <div class="container">
        <Title :info="data.digital.title" />
        <div class="line"> 
          <div class="person-list">
            <Person v-for="(item, i) in digPer" :info="item" :key="i" :isMobile="isMobile"/>
          </div>
          <div class="load-more" v-if="digPer.length === 8" @click="getMore('digPer')">
            <More title="查看更多文章" />
          </div>
        </div>
        <div class="video-list">
          <VideoItem v-for="(item, i) in digVid" :info="item" :key="i"/>
        </div>
        <div class="load-more" v-if="digVid.length === 4" @click="getMore('digVid')">
          <More title="查看更多视频" />
        </div>
      </div>
      <img class="num1" src="./assets/img/num-1.png" alt="">
      <img class="num2" src="./assets/img/num-2.png" alt="">
      <img class="num3" src="./assets/img/num-3.png" alt="">
    </div>
    <!-- 开源创新 -->
    <div class="part open" id="open">
      <div class="container">
        <Title :info="data.open.title" />
        <div class="line"> 
          <div class="person-list">
            <Person v-for="(item, i) in openPer" :info="item" :key="i" :isMobile="isMobile"/>
          </div>
          <div class="load-more" v-if="openPer.length === 8" @click="getMore('openPer')">
            <More title="查看更多文章" />
          </div>
        </div>
        <div class="video-list">
          <VideoItem v-for="(item, i) in openVid" :info="item" :key="i" />
        </div>
        <div class="load-more" v-if="openVid.length === 4" @click="getMore('openVid')">
          <More title="查看更多视频" />
        </div>
      </div>
    </div>
    <!-- 业界资讯 -->
    <div class="part news" id="news">
      <div class="container">
        <Title :info="data.news.title" />
        <div class="article-list">
          <ArticleItem v-for="(item, i) in data.news.articleList" :info="item" :key="i"/>
        </div>
        <div class="load-more">
          <More :title="data.news.btnTitle" :link="data.news.btnLink" type="solid" />
        </div>
      </div>
      <img class="new1" src="./assets/img/new-1.png" alt="">
      <img class="new2" src="./assets/img/new-2.png" alt="">
    </div>
    <div class="part logo" id="support">
      <div class="container">
        <Title :info="data.support.title" />
        <LogoItem class="logoList" v-for="(item, i) in data.support.partners" :info="item" :key="i"></LogoItem>
      </div>
    </div>
  </div>
<edit :data="data" :debug="false"></edit>
</div>
</template>

<script>
import axios from 'axios'
import data from './data'
import download from './vender/download'
import temp from './temp'
import Edit from 'common/components/edit'

import Title from './components/title'
import Person from './components/person'
import VideoItem from './components/videoItem'
import ArticleItem from './components/articleItem'
import LogoItem from './components/logoItem'
import More from './components/more'
import Nav from './components/nav'

export default {
  components: {
    Title,
    Person,
    VideoItem,
    ArticleItem,
    LogoItem,
    More,
    Nav,
    Edit
  },
  data () {
    var d = window.GEEKBANG_DATA || data
    return {
      screenWidth: document.body.clientWidth,
      status: 'prod', // prod, editing
      data: d,
      isMobile: false,
      digPer: d.digital.personList.slice(0, 8),
      digVid: d.digital.videoList.slice(0, 4),
      openPer: d.open.personList.slice(0, 8),
      openVid: d.open.videoList.slice(0, 4)
    }
  },
  computed: {
  },
  created () {
    this.initWxConfig()
    if (window.location.protocol.indexOf('file') > -1 ||
        window.location.search.indexOf('status=editing') > -1) {
      this.status = 'editing'
    }

    let winWidth = 0
    if (window.innerWidth) {
      winWidth = window.innerWidth
    } else if ((document.body) && (document.body.clientWidth)) {
      winWidth = document.body.clientWidth
    }
    this.isMobile = winWidth < 768 ? true : false
    console.log(this.isMobile)
  },
  mounted () {
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  },
  methods: {
    initWxConfig () {
      let data = this.data['微信分享']
      const ua = window.navigator.userAgent
      if (!ua.match(/MicroMessenger/i)) return
      let url = window.location.href
      axios.get(`https://misc.geekbang.org/wxmisc/wxshare/sign?url=${encodeURIComponent(url)}&mpid=gh_a4dbefba05a2`)
      .then(res => {
        if (res.data.code === 0) {
          if (!window.wx) return
          window.wx.config({
            debug: false,
            appId: res.data.data.appId,
            timestamp: res.data.data.timestamp,
            nonceStr: res.data.data.nonceStr,
            signature: res.data.data.signature,
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
          })
        }
      }).catch(res => {
      })
      window.wx.ready(function () {
        window.wx.onMenuShareTimeline({
          title: data['标题'],
          imgUrl: data['图片'],
          link: window.location.href,
          success: function () {},
          cancel: function () {}
        })
        window.wx.onMenuShareAppMessage({
          title: data['标题'],
          desc: data['介绍'],
          imgUrl: data['图片'],
          link: window.location.href,
          type: 'link',
          dataUrl: '',
          success: () => {},
          cancel: () => {}
        })
      })
    },
    getMore (type) {
      switch (type) {
        case 'digPer':
          this.digPer = data.digital.personList
          break;
        case 'digVid':
          this.digVid = data.digital.videoList
          break;
        case 'openPer':
          this.openPer = data.open.personList
          break;
        case 'openVid':
          this.openVid = data.open.videoList
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'alibaba';
  // src: url('./assets');
}
.container {
  position: relative; z-index: 3;
  margin: 0 auto;
  width: 1140px;

  @include isMobile {
    width: 86%;
  }
}
img {
  width: 100%;
}
.main {

  & .part {
    position: relative;
  }

  & .banner {
    position: relative;
    min-width: 1140px;
    height: 695px;
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;

    @include isMobile {
      height: 550px;
      min-width: 100%;
    }

    & .banner-btn {
      position: absolute; bottom: 17%; left: 50%;
      transform: translateX(-50%);

      @include isMobile {
        bottom: 145px;
        color: #017971;
      }
    }
  }

  & .desc {
    padding: 70px 0 60px;
    background: #FAFAFA;
    line-height: 1.7;
    @include font(18, 400);
    color: $black;

    @include isMobile {
      padding: 35px 0 20px;
      @include font(15, 400);
      text-align: justify;
    }

    & /deep/ p {
      margin-bottom: 10px;
      span {
        color: $deepBlue;
        font-weight: 500;
      }
    }
  }

  & .line {
    position: relative;
    margin-bottom: 44px;
    @include isMobile {
      margin-bottom: 20px;
    }

    &::after {
      content: '';
      position: absolute; bottom: 0; left: 0;
      width: 100%;
      height: 1px;
      background: url('./assets/img/line.png') center center/contain;
    }
  }

  & .person-list {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    //  justify-content: space-between;
    // padding-top: 52px;
    padding-bottom: 43px;

    @include isMobile {
      padding-bottom: 20px;
    }

    & /deep/ .person.pc {
      margin-right: 70px;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }

  & .video-list {
    display: flex; flex-wrap: wrap; justify-content: space-between;
    padding-bottom: 70px;

    @include isMobile {
      padding-bottom: 40px;
    }
  }

  & .article-list {
    display: flex; flex-wrap: wrap; justify-content: space-between;
    margin-top: 30px;

    @include isMobile {
      margin-top: 20px;
    }
  }

  & .load-more {
    position: relative;
    padding-bottom: 60px;
    z-index: 2;
    @include isMobile {
      padding-bottom: 40px;
    }
  }

  & .logoList {
    padding-top: 40px;
    @include isMobile {
      padding-top: 20px;
    }
  }

  & .num {
    img {
      position: absolute; z-index: -1;
      @include isMobile {
        display: none;
      }
    }
    .num1 {
      right: 0; top: 125px;
      width: 705px;
    }
    .num2 {
      left: 0; top: 50%;
      transform: translateY(-50%);
      width: 434px;
    }
    .num3 {
      right: 0; bottom: 0;
      width: 544px;
    }
  }

  & .news {
    background: #FFF;

    img {
      position: absolute; z-index: 1;
      @include isMobile {
        display: none;
      }
    }

    & .new1 {
      left: 0; top: 0;
      width: 812px;
    }
    & .new2 {
      right: 0; bottom: 0;
      width: 797px;
    }
  }

  & .open,
  & .logo {
    background: #F9F9F9;

    & .load-more /deep/ .border{
      background: #F9F9F9;
    }
  }

  & .logo {
    padding-bottom: 50px;
  }
}

</style>
